export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute inset-0 bg-gradient-to-br from-background-100/50 via-background-50 to-background-50"></div>
        <div className="absolute top-20 right-10 w-96 h-96 rounded-full bg-primary-500/5 blur-3xl"></div>
        <div className="absolute bottom-20 left-10 w-80 h-80 rounded-full bg-accent-500/5 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 mb-4">
              <span className="px-3 py-1 text-xs font-label text-accent-400 bg-accent-500/10 rounded-full border border-accent-500/20">
                每日更新
              </span>
              <span className="px-3 py-1 text-xs font-label text-primary-400 bg-primary-500/10 rounded-full border border-primary-500/20">
                4K蓝光
              </span>
              <span className="px-3 py-1 text-xs font-label text-secondary-300 bg-secondary-500/10 rounded-full border border-secondary-500/20">
                无广告
              </span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-3">
              90影视
              <span className="block text-primary-400 text-xl sm:text-2xl md:text-3xl lg:text-4xl mt-1">
                高清超清影视在线观看平台
              </span>
            </h1>

            <p className="text-lg sm:text-xl text-foreground-500 mb-3 font-heading">
              极致画质 · 即刻畅享
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              90影视为您精选海量高清超清4K蓝光1080P画质电影电视剧资源，涵盖动作、悬疑、喜剧、科幻、爱情等全品类内容。
              每日同步更新最新院线大片与热门剧集，无需注册即可免费在线观看，全程无缓冲流畅播放，
              为您带来沉浸式家庭影院级别视觉体验。
            </p>

            <div className="flex items-center justify-center lg:justify-start gap-6 mb-7 text-sm text-foreground-500 flex-wrap">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span>日更新 50+ 部</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                <span>高清片库 10万+</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
                <span>全网CDN加速</span>
              </div>
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-3 flex-wrap">
              <a
                href="#media"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector('#media');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-label text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector('#ranking');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-200/70 hover:bg-background-300/70 text-foreground-700 font-label text-sm rounded-md border border-background-300/60 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-lg overflow-hidden aspect-[4/3] bg-background-100/50 border border-background-200/40">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20interior%20with%20warm%20golden%20spotlight%20illuminating%20a%20velvet%20curtain%20stage%2C%20dramatic%20atmospheric%20lighting%20with%20deep%20shadows%2C%20luxurious%20red%20and%20gold%20accents%2C%20film%20projector%20beam%20cutting%20through%20darkness%2C%20elegant%20art%20deco%20details%2C%20cinematic%20composition%20with%20rich%20contrast&width=800&height=600&seq=hero-visual-90movies&orientation=landscape"
                alt="90影视 - 高清影院级观影体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                <span className="px-2 py-1 text-xs font-label bg-background-50/80 text-foreground-700 rounded backdrop-blur-sm">
                  4K HDR
                </span>
                <span className="px-2 py-1 text-xs font-label bg-background-50/80 text-foreground-700 rounded backdrop-blur-sm">
                  杜比全景声
                </span>
                <span className="px-2 py-1 text-xs font-label bg-background-50/80 text-foreground-700 rounded backdrop-blur-sm">
                  蓝光原盘
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}